<template>
  <div
    class="uk-flex uk-flex-center uk-width-1-1"
    uk-grid="masonry: true"
  >
    <main-card
      v-for="p in displayedPosts"
      :key="p.index"
      :date-time-html="p.dthtml"
      :image-source="p.imgsrc"
      :alt-text="p.alt"
      :post-url="p.url"
    >
      <template v-slot:title>
        {{ p.title }}
      </template>
      <template v-slot:date>
        {{ p.date }}
      </template>
      <template v-slot:badge>
        {{ p.badge }}
      </template>
      <template v-slot:preview>
        <div class="string-correction">
          {{ p.preview }}
        </div>
      </template>
    </main-card>
  </div>
</template>

<script>
import MainCard from '@/components/card-templates/MainCard.vue'
import { posts } from '@/posts.js'

export default {
  components: {
    MainCard
  },
  props: {
    postsOrder: {
      type: String,
      required: true
    },
    searchCriteria: {
      type: String,
      required: true
    },
    searchFilter: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      myPosts: posts
    }
  },
  computed: {
    postsInSelectedOrder () {
      var postsInUserOrder = null
      if (this.postsOrder === 'New-Old') {
        postsInUserOrder = this.myPosts.slice().reverse()
      } else if (this.postsOrder === 'Old-New') {
        postsInUserOrder = this.myPosts
      } return postsInUserOrder
    },
    displayedPosts () {
      return this.postsInSelectedOrder.filter((element) => {
        return element[this.searchCriteria].toLowerCase().match(this.searchFilter.toLowerCase())
      })
    }
  }
}
</script>

<style>
  .string-correction {
    white-space: pre-line;
  }
</style>
